import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@storable/canaveral-components';
import { Tab, Nav } from 'react-bootstrap';
import cx from 'classnames';
import { browserHistory, withRouter } from 'react-router';
import { MANAGE } from '../../../modules/authorization/actions';
import { BUILDER, NAVIGATION, SEO_PAGES, SEO_REDIRECTS } from '../../../modules/authorization/subjects';
import useCurrentUser from '../../hooks/useCurrentUser';
import AdvancedSettingsButton from '../../containers/AdvancedSettingsButton';
import useFlipper from '../../../modules/react/hooks/useFlipper';
import styles from './styles.scss';
import { FLIPPER_VOYAGER_ADMIN_DOMAIN_SSL_SETTINGS } from '../../../constants/flippers';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  children: undefined,
};

const Settings = ({ children, location }) => {
  const currentUser = useCurrentUser();
  const domainSSLTabEnabled = useFlipper(FLIPPER_VOYAGER_ADMIN_DOMAIN_SSL_SETTINGS);

  const authBuilder = currentUser.can(MANAGE, BUILDER);
  const authSEOPages = currentUser.can(MANAGE, BUILDER, SEO_PAGES);
  const authNavigation = currentUser.can(MANAGE, BUILDER, NAVIGATION);
  const authSEORedirects = currentUser.can(MANAGE, BUILDER, SEO_REDIRECTS);

  const handleTabSelect = (route) => {
    browserHistory.push(route);
  };

  // TODO - create a canaveral component that uses react-router's <Link>
  // instead of having to manually push to browser history
  return (
    <Grid fluid className={styles.settings}>
      <Tab.Container
        activeKey={location.pathname}
        onSelect={handleTabSelect}
        id="settingsTabs"
      >
        <Nav variant="tabs" justified={false}>
          <Nav.Item
            className={cx({ [styles.unauthorized]: !authSEOPages })}
            activeKey={location.pathname}
          >
          <Nav.Link eventKey="/admin/settings/pages">Page Settings</Nav.Link>
          </Nav.Item>
          <Nav.Item
            className={cx({ [styles.unauthorized]: !authNavigation })}
          >
           <Nav.Link eventKey="/admin/locales/en-us/navigation/edit"> Navigation</Nav.Link>
          </Nav.Item>
          <Nav.Item>
           <Nav.Link eventKey="/admin/settings/analytics">Analytics</Nav.Link>
          </Nav.Item>
          {!domainSSLTabEnabled && (
            <Nav.Item
              className={cx({ [styles.unauthorized]: !authBuilder })}
            >
             <Nav.Link eventKey="/admin/settings/domains">Domains</Nav.Link>
            </Nav.Item>
          )}
          {domainSSLTabEnabled && (
            <Nav.Item
              className={cx({ [styles.unauthorized]: !authBuilder })}
            >
              <Nav.Link eventKey="/admin/settings/domains-ssl">Domains & SSL Certificates</Nav.Link>
            </Nav.Item>
          )}
            <Nav.Item
              className={cx({ [styles.unauthorized]: !authSEORedirects })}
            >
             <Nav.Link eventKey="/admin/settings/redirects">Redirects</Nav.Link>
            </Nav.Item>
          {!domainSSLTabEnabled && (
            <Nav.Item
              className={cx({ [styles.unauthorized]: !authBuilder })}
            >
             <Nav.Link eventKey="/admin/settings/ssl">SSL Certificates</Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item
            className={cx({ [styles.unauthorized]: !authSEOPages })}
          >
           <Nav.Link eventKey="/admin/settings/robots">robots.txt</Nav.Link>
          </Nav.Item>
        </Nav>
      </Tab.Container>
      <AdvancedSettingsButton />
      <div className={styles.container}>
        {children}
      </div>
    </Grid>
  );
};

Settings.propTypes = propTypes;
Settings.defaultProps = defaultProps;

export default withRouter(Settings);
